module.exports = __webpack_public_path__ + "static/media/DK4055_03.cf4fc702.jpg";